import React from 'react';

const SkipToContent = ({ targetId = 'main-content' }) => {
  return (
    <a
      href={`#${targetId}`}
      className="skip-to-content"
      style={styles.skipLink}
      onFocus={(e) => { e.target.style.top = '0'; }}
      onBlur={(e) => { e.target.style.top = '-100px'; }}
    >
      Skip to main content
    </a>
  );
};

const styles = {
  skipLink: {
    position: 'absolute',
    top: '-100px',
    left: '0',
    backgroundColor: '#6366f1',
    color: '#ffffff',
    padding: '8px 16px',
    zIndex: 10000,
    fontSize: '14px',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'top 0.2s ease',
  },
};

export default SkipToContent;
